import { Position } from '@xyflow/react';
import { layoutFromMap, TreeNode } from 'entitree-flex';
import type { Node } from '@xyflow/react';
import { EntitreeNodesAndEdges } from '../../typesV2';
const { Top, Bottom, Left, Right } = Position;

const nodeWidth = 150;
const nodeHeight = 36;

const entitreeSettings = {
  clone: true, // returns a copy of the input, if your application does not allow editing the original object
  enableFlex: true, // has slightly better perfomance if turned off (node.width, node.height will not be read)
  firstDegreeSpacing: 100, // spacing in px between nodes belonging to the same source, eg children with same parent
  nextAfterAccessor: 'spouses', // the side node prop used to go sideways, AFTER the current node
  nextAfterSpacing: 100, // the spacing of the "side" nodes AFTER the current node
  nextBeforeAccessor: 'siblings', // the side node prop used to go sideways, BEFORE the current node
  nextBeforeSpacing: 100, // the spacing of the "side" nodes BEFORE the current node
  nodeHeight, // default node height in px
  nodeWidth, // default node width in px
  orientation: 'vertical', // "vertical" to see parents top and children bottom, "horizontal" to see parents left and
  rootX: 0, // set root position if other than 0
  rootY: 0, // set root position if other than 0
  secondDegreeSpacing: 100, // spacing in px between nodes not belonging to same parent eg "cousin" nodes
  sourcesAccessor: 'parents', // the prop used as the array of ancestors ids
  sourceTargetSpacing: 340, // the "vertical" spacing between nodes in vertical orientation, horizontal otherwise
  targetsAccessor: 'children', // the prop used as the array of children ids
};

const pluralisticNodeWidth = 760;
const pluralisticNodeHeight = 300;
const pluralisticNodeHeightWithTwoRows = 500; // todo

const normalNodeWidth = 450;
const normalNodeHeight = 450;
const subtopicHeight = 100; // a guess for now

const sideQuestNodeWidth = 260;
const sideQuestNodeHeight = 450;

export const layoutElements = (tree, rootId, direction = 'TB') => {
  const { nodes: entitreeNodes, rels: entitreeEdges } = layoutFromMap(
    rootId,
    tree,
    {
      ...entitreeSettings,
      orientation: 'vertical',
    }
  );

  // logg here

  const nodes: any[] = [];
  const edges: any[] = [];

  entitreeEdges.forEach((edge: any) => {
    const sourceNode = edge.source.id;
    const targetNode = edge.target.id;

    const newEdge: any = {};

    newEdge.id = 'e' + sourceNode + targetNode;
    newEdge.source = sourceNode;
    newEdge.target = targetNode;
    newEdge.type = 'bezier';
    newEdge.animated = 'true';

    // Check if target node is spouse or sibling
    const isTargetSpouse = !!edge.target.isSpouse;
    const isTargetSibling = !!edge.target.isSibling;

    if (isTargetSpouse) {
      newEdge.sourceHandle = Right;
      newEdge.targetHandle = Left;
    } else if (isTargetSibling) {
      newEdge.sourceHandle = Left;
      newEdge.targetHandle = Right;
    } else {
      newEdge.sourceHandle = Bottom;
      newEdge.targetHandle = Top;
    }

    edges.push(newEdge);
  });

  let coreNodeNumber = 0;
  let showNodeOnLeft = true;
  const sideQuestIsLeftArray: boolean[] = [];

  let addedHeight = 0;
  // index of the side quest node
  let sideQuestIndex = 0;

  let prevNode;
  entitreeNodes.forEach((node: any) => {
    const newNode: any = {};

    const isSpouse = !!node?.isSpouse;
    const isSibling = !!node?.isSibling;
    const isRoot = node?.id === rootId;

    if (isSpouse) {
      newNode.sourcePosition = Right;
      newNode.targetPosition = Left;
    } else if (isSibling) {
      newNode.sourcePosition = Left;
      newNode.targetPosition = Right;
    } else {
      newNode.sourcePosition = Bottom;
      newNode.targetPosition = Top;
      coreNodeNumber++;
    }

    newNode.data = { label: node.name, direction, isRoot, ...node };
    newNode.id = node.id;
    newNode.type = newNode.data.type;

    //default
    newNode.width = nodeWidth;
    const startingY = node.y + addedHeight;
    newNode.position = {
      x: node.x,
      y: startingY,
    };
    // newNode.position = {
    //   x: coreNodeNumber === 1 ? node.x : showNodeOnLeft ? node.x - 150 : node.x + 150,
    //   y: isSpouse || isSibling ? startingY : startingY
    // };
    if (newNode.type === 'start') {
      newNode.width = 300;
      newNode.position.x = 55;
      addedHeight -= 150;
      // newNode.height = 450;
    }

    if (newNode.type === 'end') {
      newNode.width = 300;
      newNode.position.x = 55;
      // newNode.height = 450;
    }

    //pluralistic
    if (newNode.type === 'pluralistic') {
      // const rows = Math.ceil(node.options?.length / 2) + 1;
      newNode.width = pluralisticNodeWidth;
      // newNode.height = pluralisticNodeHeight;
      newNode.position.x = 0 - (pluralisticNodeWidth - nodeWidth) / 2 + 130; // center minus half of width
      newNode.position.y = startingY + 20;
      addedHeight += pluralisticNodeHeight - 140;
      addedHeight += (node.options?.length - 1) * 120;
      if (node.options?.length > 3) addedHeight += 100;
      // newNode.height = 00;
    } else if (newNode.type === 'normal') {
      const totalSectionsDescriptionsLength =
        node.sections?.reduce(
          (acc, curr) => acc + (curr.subTopicTitle.length > 20 ? 1 : 0),
          0
        ) ?? 0;
      const shouldAddLengthDueToSectionsLength =
        totalSectionsDescriptionsLength >= node.sections?.length - 1;

      const shouldAddLengthDueToDescriptionLength1 =
        newNode.data.topicDescription.length > 130;

      const shouldAddLengthDueToDescriptionLength2 =
        newNode.data.topicDescription.length > 150;

      const shouldAddLengthDueToDescriptionLength3 =
        newNode.data.topicDescription.length > 160;

      const manyNodesAndLongSections =
        node.sections?.length > 3 && node.sections?.length - 1;

      const numberOfSections = node.sections?.length ?? 0;
      newNode.width = normalNodeWidth;
      // newNode.height = normalNodeHeight;
      const leftRightShift = !node.nodeOnLeft ? 140 : -175;
      newNode.position.x = 0 + leftRightShift; // center minus half of width
      addedHeight += normalNodeHeight;
      addedHeight += 100 * (numberOfSections - 3);
      if (shouldAddLengthDueToSectionsLength) addedHeight += 100;
      if (manyNodesAndLongSections) addedHeight += 100;
      if (shouldAddLengthDueToDescriptionLength1) addedHeight += 50;
      if (shouldAddLengthDueToDescriptionLength2) addedHeight += 50;
      if (shouldAddLengthDueToDescriptionLength3) addedHeight += 100;
      newNode.data.sideQuestSourcePosition = !node.nodeOnLeft ? Left : Right;

      if (!node.nodeOnLeft) {
        newNode.sourcePosition = Left;
      } else {
        newNode.sourcePosition = Right;
      }
    } else if (newNode.type === 'sideQuest') {
      newNode.width = sideQuestNodeWidth;

      // spouse farther right than sibling for some reason -- adjust both
      // newNode.position.x = node.x + 55;

      const parentNode = tree[node.parentId];
      const parentSubtopicsLength = parentNode?.sections?.length;

      // newNode.position.y = startingY - normalNodeHeight + (parentSubtopicsLength * subtopicHeight) + 60
      // if (node.sideQuests?.length === 1) newNode.position.y = newNode.position.y + 100;
      newNode.position.y = startingY - 230;
      if (node.sideQuests?.length === 1) newNode.position.y += 100;
      if (node.sideQuests?.length === 3) newNode.position.y -= 100;
      // addedHeight += 100 * (parentSubtopicsLength - 2);
      newNode.position.y -= 20 * (parentSubtopicsLength - 3);

      const leftRightShift = node.isSibling ? -178 : 333;
      newNode.position.x = 0 + leftRightShift;

      if (isSibling) {
        newNode.targetPosition = Right;
      } else {
        newNode.targetPosition = Left;
      }
    }

    newNode.position.x = newNode.position.x;
    // newNode.height = nodeHeight;

    nodes.push(newNode);
    prevNode = newNode;
  });

  return { nodes, edges };
};
